import { render, staticRenderFns } from "./RegisterPassword.vue?vue&type=template&id=0a75f1d2&scoped=true&"
import script from "./RegisterPassword.vue?vue&type=script&lang=js&"
export * from "./RegisterPassword.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPassword.vue?vue&type=style&index=0&id=0a75f1d2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a75f1d2",
  null
  
)

export default component.exports